import { NextResponse } from 'next/server'
import { query, uuid } from '@/lib/db'

export async function POST(req: Request) {
  const { shop_id, user_id, caisse_session_id, montant, note } = await req.json()
  const id = uuid()
  await query(
    'INSERT INTO retraits (id, shop_id, user_id, caisse_session_id, montant, note) VALUES (?, ?, ?, ?, ?, ?)',
    [id, shop_id, user_id, caisse_session_id || null, montant, note]
  )
  return NextResponse.json({ id })
}
